const ActiveState = {
    NONE: -1,
}

export default ActiveState
